import embry from "./embry";
export default { embry }